/**
 * NutriKit FAQ search (page contact, self-service avant le formulaire).
 * Live filter on question + answer text + category. Pure vanilla JS, no deps.
 * Smart empty state with smooth scroll-to-form CTA.
 */
(function () {
  'use strict';

  function init() {
    var input = document.getElementById('nk-faq-search-input');
    var filtersWrap = document.querySelector('.nutrikit-contact__search-filters');
    var counter = document.querySelector('[data-faq-counter]');
    var list = document.querySelector('[data-faq-list]');
    var emptyEl = document.querySelector('[data-faq-empty]');
    var emptyTermEl = document.querySelector('[data-faq-empty-term]');
    var emptyCta = document.querySelector('[data-faq-empty-cta]');
    if (!input || !list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('details'));
    if (items.length === 0) return;

    var totalCount = items.length;
    var activeFilter = (filtersWrap && filtersWrap.dataset.defaultFilter) || 'all';
    var searchTerm = '';

    function normalize(s) {
      return (s || '').toString().toLowerCase().trim();
    }

    function applyFilter() {
      var visibleCount = 0;
      items.forEach(function (item) {
        var q = item.dataset.question || '';
        var a = item.dataset.answer || '';
        var cat = item.dataset.category || '';

        var matchesCategory = activeFilter === 'all' || cat === activeFilter;
        var matchesSearch = !searchTerm ||
          q.indexOf(searchTerm) !== -1 ||
          a.indexOf(searchTerm) !== -1;

        var visible = matchesCategory && matchesSearch;
        item.hidden = !visible;
        if (!visible && item.open) item.open = false;
        if (visible) visibleCount++;
      });

      if (counter) {
        if (visibleCount === totalCount && !searchTerm && activeFilter === 'all') {
          counter.textContent = totalCount;
        } else if (visibleCount === 0) {
          counter.textContent = '0';
        } else if (visibleCount === 1) {
          counter.textContent = '1';
        } else {
          counter.textContent = visibleCount;
        }
      }

      if (emptyEl) {
        if (visibleCount === 0) {
          emptyEl.hidden = false;
          if (emptyTermEl) {
            if (searchTerm) {
              emptyTermEl.textContent = ' pour "' + searchTerm + '"';
            } else if (activeFilter !== 'all') {
              emptyTermEl.textContent = ' dans la catégorie "' + activeFilter + '"';
            } else {
              emptyTermEl.textContent = '';
            }
          }
        } else {
          emptyEl.hidden = true;
        }
      }
    }

    input.addEventListener('input', function (e) {
      searchTerm = normalize(e.target.value);
      applyFilter();
    });

    if (filtersWrap) {
      filtersWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-filter]');
        if (!btn) return;
        activeFilter = btn.dataset.filter || 'all';
        var allBtns = filtersWrap.querySelectorAll('[data-filter]');
        for (var i = 0; i < allBtns.length; i++) {
          allBtns[i].classList.toggle('is-active', allBtns[i] === btn);
        }
        applyFilter();
      });
    }

    // Apply initial filter (e.g. default = 'Produit')
    applyFilter();

    if (emptyCta) {
      emptyCta.addEventListener('click', function (e) {
        var href = emptyCta.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var firstField = target.querySelector('select, input, textarea');
        if (firstField) {
          setTimeout(function () { firstField.focus(); }, 600);
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
